import React, { useMemo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { times } from '@beef/utils';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var MARQUEE_SYMBOL = 320;
var MARQUEE_DEFAULT_REPEAT = 4;
var MARQUEE_ANIMATION_DURATION = 45;
export var MarqueeText = function MarqueeText(_ref) {
  var text = _ref.text,
    url = _ref.url;
  var Tag = url ? 'a' : 'div';
  var repeatTimes = useMemo(function () {
    return (text === null || text === void 0 ? void 0 : text.length) < MARQUEE_SYMBOL ? Math.ceil(MARQUEE_SYMBOL / text.length) : MARQUEE_DEFAULT_REPEAT;
  }, [text]);
  return text ? /*#__PURE__*/React.createElement(Tag, {
    className: cx('marquee-wrap'),
    href: url
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('marquee'),
    style: {
      animationDuration: "".concat(MARQUEE_ANIMATION_DURATION, "s")
    }
  }, times(repeatTimes, function () {
    return /*#__PURE__*/React.createElement(Text, {
      lineHeight: 24,
      size: 16
    }, text);
  }))) : null;
};